(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('SafraDetailController', SafraDetailController);

    SafraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Safra', 'Propriedade', 'Custosnwfertilizantes', 'Custosnwdefensivos', 'Indicadoresnw', 'Custosnwproducao', 'Custoshabituaisproducao', 'Indicadoreshabituais', 'Custoshabituaisdefensivos', 'Custoshabituaisfertilizantes', 'Cultura', 'Etapa', 'Preplantioplan', 'Preplantio', 'Plantioplan', 'Plantio', 'Colheitaplan', 'Colheita', 'Armazenamentosafraplan', 'Armazenamentosafra', 'Manutencaosafraplan', 'Comercializacaoplan', 'Comercializacao', 'Entregasafracomercplan', 'Entregasafracomerc', 'Logentregaarmazplan', 'Logentregaarmaz', 'Logrecinsumoplan', 'Logrecinsumo', 'Manutencaosafra'];

    function SafraDetailController($scope, $rootScope, $stateParams, previousState, entity, Safra, Propriedade, Custosnwfertilizantes, Custosnwdefensivos, Indicadoresnw, Custosnwproducao, Custoshabituaisproducao, Indicadoreshabituais, Custoshabituaisdefensivos, Custoshabituaisfertilizantes, Cultura, Etapa, Preplantioplan, Preplantio, Plantioplan, Plantio, Colheitaplan, Colheita, Armazenamentosafraplan, Armazenamentosafra, Manutencaosafraplan, Comercializacaoplan, Comercializacao, Entregasafracomercplan, Entregasafracomerc, Logentregaarmazplan, Logentregaarmaz, Logrecinsumoplan, Logrecinsumo, Manutencaosafra) {
        var vm = this;

        vm.safra = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('netWordAgroApp:safraUpdate', function(event, result) {
            vm.safra = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
